module.exports = __webpack_public_path__ + "523fad52a7a1bef1d232f58e37af9562.MP3";